import React from 'react';
import { IonMenu, IonHeader, IonToolbar, IonContent, IonList, IonItem, IonLabel, IonMenuToggle, IonIcon } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { barChartOutline, bookOutline, callOutline, keypadOutline, micCircleOutline, peopleCircleOutline, personOutline } from 'ionicons/icons';
import { useAuthStore } from '../../store/useAuthStore';
import { menuItems, robotOutline } from '../../config/menuItems';
import { useRefresh } from '../../contexts/RefreshContext';
import revLogo from '../../assets/REV_logo.svg';

const ionIconMap: Record<string, string> = {
  barChartOutline,
  bookOutline,
  callOutline,
  peopleCircleOutline,
  personOutline,
  robotOutline,
  keypadOutline,
  micCircleOutline,
};

interface MobileSidebarProps {
  disabled: boolean;
}

export function MobileSidebar({ disabled }: MobileSidebarProps) {
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();
  const { triggerRefresh } = useRefresh();

  // Filter menu items based on shouldShow
  const visibleMenuItems = menuItems.filter((item) => {
    if (!item.shouldShow) return true;
    return item.shouldShow();
  });

  return (
    <IonMenu disabled={disabled} side="start" contentId="main-content" type="overlay" className="mobile-menu">
      <IonHeader>
        <IonToolbar className="bg-white">
          <div className="flex items-center px-4 py-4">
            <img src={revLogo} alt="REV Logo" className="h-6 w-auto dark:hidden" />
            <img src={revLogo} alt="REV Logo" className="h-6 w-auto hidden dark:block" />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          {isAuthenticated && (
            <IonMenuToggle>
              {visibleMenuItems.map((item, index) => {
                const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
                const isMain = item.isMain === true;
                const prevItem = index > 0 ? visibleMenuItems[index - 1] : null;
                const showDivider = prevItem && prevItem.isMain && !isMain;

                return (
                  <React.Fragment key={item.path}>
                    {showDivider && (
                      <div className="mx-4 my-2 border-t border-gray-200" />
                    )}
                    <IonItem
                      detail={false}
                      routerLink={item.path}
                      routerDirection="none"
                      button
                      className={isActive ? 'nav-menu-item-active' : ''}
                      onClick={() => triggerRefresh(item.path)}
                    >
                      {item.ionIcon && ionIconMap[item.ionIcon] ? (
                        <IonIcon slot="start" icon={ionIconMap[item.ionIcon]} className="text-xl mr-3" />
                      ) : item.icon ? (
                        <img slot="start" src={item.icon} alt={item.label} className={`w-6 h-6 mr-3 ${!isMain ? 'opacity-90' : ''}`} />
                      ) : null}
                      <IonLabel className={!isMain ? 'text-gray-500' : ''}>{item.label}</IonLabel>
                    </IonItem>
                  </React.Fragment>
                );
              })}
            </IonMenuToggle>
          )}
        </IonList>

        {/* Version Number - Bottom Left Corner */}
        <div className="fixed bottom-2 left-2 text-[8px] text-gray-400">
          {import.meta.env.VITE_VERSION}
        </div>
      </IonContent>
    </IonMenu>
  );
}
